import React, { Component } from "react";

// Components
import TopHeader from "./TopHeader";
import MainNav from "./MainNav";

class Header extends Component {
	render() {
		return (
			<header>
				<TopHeader />
				<MainNav />
			</header>
		);
	}
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js